import React, { useState, useRef } from "react";
import PackageJson from "../../../package.json";
import { GameStore } from "../../interfaces/game.interface";
import { Carousel } from "antd";
import { CarouselRef } from "antd/es/carousel";
import { useDraggable } from "react-use-draggable-scroll";

export const GCCarouselGame = (games: GameStore) => {
  return (
    <Carousel
      swipeToSlide
      draggable
      autoplay
      autoplaySpeed={12000}
      infinite
      className="carauselHead"
      arrows
    >
      <div className="w-full h-[480px]">
        <div className="w-full h-full relative flex py-6">
          <img
            src={`${PackageJson.homepage}/games/GameCenterBanner.png`}
            className="absolute left-1/2 top-0 transform -translate-x-1/2 h-full object-cover"
            alt=""
          />
          <div className="bgLinierCarousel absolute left-0 top-0 w-full h-full"></div>
        </div>
      </div>
      <div className="w-full h-[480px]">
        <div className="w-full h-full relative flex py-6">
          <img
            src={`${PackageJson.homepage}/games/newgames-banner.png`}
            className="absolute left-1/2 top-0 transform -translate-x-1/2 h-full object-cover"
            alt=""
          />
          <div className="bgLinierCarousel absolute left-0 top-0 w-full h-full"></div>
        </div>
      </div>
    </Carousel>
  );
};

export const GCCarouselGameDetail = ({
  screenshots,
}: {
  screenshots: string[];
}) => {
  const settings = {
    dots: true,
    infinite: false,
    swipeToSlide: true,
    draggable: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoPlay: false,
  };

  const slider1 = useRef<CarouselRef>(null);

  const [activeSlide, setActiveSlide] = useState<number>(0);
  const change1Handler = (currentSlideNum: number) => {
    setActiveSlide(currentSlideNum);
  };

  const ref = useRef<HTMLElement>() as React.MutableRefObject<HTMLInputElement>;
  const { events } = useDraggable(ref);
  return (
    <>
      <Carousel
        {...settings}
        ref={slider1}
        className="mb-6 shadowActive -mx-[15px]"
        afterChange={change1Handler}
        arrows
      >
        {screenshots.map((imgUrl, i) => {
          return (
            <div key={i} className="w-full h-[400px] px-[15px]">
              <div className="w-full h-full relative flex py-6 justify-center items-center">
                <img
                  src={imgUrl}
                  className="max-w-full max-h-full object-cover"
                  alt=""
                />
              </div>
            </div>
          );
        })}
      </Carousel>

      <div className="w-full flex items-center justify-between">
        <div
          className="w-full px-4 overflow-x-auto scrolStyle pb-4"
          ref={ref}
          {...events}
        >
          <div className="w-fit flex items-center gap-4">
            {screenshots.map((imgUrl, i) => {
              return (
                <div
                  className={`w-64 px-[15px] ${
                    activeSlide === i ? "border-4" : ""
                  }`}
                  key={i}
                  onClick={() => slider1.current?.goTo(i)}
                >
                  <div className="w-full h-[130px] relative mx-auto flex justify-center">
                    <img
                      src={imgUrl}
                      className="max-w-full max-h-full object-cover rounded-[6px]"
                      alt=""
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
